import React, { ReactNode } from 'react';
import styled from 'styled-components';

import { Icon } from '@/ui/Icon';

const RootStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
`;

const FileStyled = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
`;

const IconStyled = styled(Icon)`
  flex-shrink: 0;
  font-size: 12px;
  color: ${(p) => p.theme.colors.neutral.outline2};
`;

const FileNameStyled = styled.span`
  ${(p) => p.theme.typography.caption};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: ${(p) => p.theme.colors.neutral.onContainer};
`;

type CsvImportFileRowProps = {
  fileName: string;
  /** Trailing control, e.g. an "Upload a different file" link button. */
  action?: ReactNode;
  className?: string;
};

export const CsvImportFileRow = ({ fileName, action, className }: CsvImportFileRowProps): JSX.Element => (
  <RootStyled className={className}>
    <FileStyled>
      <IconStyled icon={['far', 'file-lines']} aria-hidden />
      <FileNameStyled title={fileName}>{fileName}</FileNameStyled>
    </FileStyled>
    {action}
  </RootStyled>
);
